import type { IEiendomToRegistration } from './IEiendomToRegistration';

export class EiendomToRegistration implements IEiendomToRegistration {
    forvalterEPost: IEiendomToRegistration['forvalterEPost'];
    forvalterNavn: IEiendomToRegistration['forvalterNavn'];
    id?: IEiendomToRegistration['id'];
    navn?: IEiendomToRegistration['navn'];
    oekonomiEPost: IEiendomToRegistration['oekonomiEPost'];
    oekonomiNavn: IEiendomToRegistration['oekonomiNavn'];

    public static empty() {
        return EiendomToRegistration.parseObject({
            forvalterEPost: '',
            forvalterNavn: '',
            id: '',
            navn: '',
            oekonomiEPost: '',
            oekonomiNavn: '',
        });
    }

    constructor(props: IEiendomToRegistration) {
        Object.assign(this, props);
    }

    public static parseObject(
        obj: IEiendomToRegistration,
    ): EiendomToRegistration {
        try {
            return new EiendomToRegistration(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Contract Registration object : ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }
}
